import { JSX } from "react";

import { Typography } from "@mui/material";
import Box from "@mui/material/Box";

export default function PriceIndicator({
  price,
}: {
  price: number;
}): JSX.Element {
  const priceIndicator = [];

  const priceSymbol = "€";

  for (let i = 0; i < 5; i++) {
    if (i < price) {
      priceIndicator.push(<Typography>{priceSymbol}</Typography>);
    } else {
      priceIndicator.push(
        <Typography sx={{ opacity: "0.5" }}>{priceSymbol}</Typography>,
      );
    }
  }

  return <Box sx={{ display: "flex" }}>{priceIndicator}</Box>;
}
